import ScrollReveal from "./ScrollReveal";
import { Home, PanelsTopLeft, Paintbrush, Check } from "lucide-react";

export default function ServicesSection() {
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-36 bg-[#0284FC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <ScrollReveal>
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white mb-4">Nos services</h2>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-8">
          <ScrollReveal delay={0.1}>
            <div data-testid="service-renovation" className="group bg-white/10 backdrop-blur-sm rounded-2xl p-8 lg:p-10 border border-white/15 hover:-translate-y-1 hover:bg-white/15 transition-all duration-300">
              <div className="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center mb-6"><Home className="w-7 h-7 text-white" /></div>
              <h3 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-white mb-3">Façades & meubles de cuisine</h3>
              <p className="text-white/70 leading-relaxed mb-6">Modernisation des portes, tiroirs, joues, plinthes et autres éléments visibles lorsque les supports sont sains et compatibles.</p>
              <a href="/covering-cuisine" className="inline-flex items-center gap-2 text-white font-semibold text-sm hover:underline">Découvrir le covering <Paintbrush className="w-4 h-4" /></a>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <div data-testid="service-surfaces" className="group bg-white/10 backdrop-blur-sm rounded-2xl p-8 lg:p-10 border border-white/15 hover:-translate-y-1 hover:bg-white/15 transition-all duration-300">
              <div className="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center mb-6"><PanelsTopLeft className="w-7 h-7 text-white" /></div>
              <h3 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-white mb-3">Plans de travail & crédences</h3>
              <p className="text-white/70 leading-relaxed mb-4">Selon l'état et la nature du support, certaines surfaces peuvent aussi être rénovées pour harmoniser l'ensemble de la cuisine.</p>
              <ul className="space-y-2 mb-6">
                {["Étude de compatibilité du support", "Choix de finitions coordonnées", "Préparation adaptée avant pose"].map((text) => <li key={text} className="flex items-start gap-3"><div className="w-5 h-5 rounded-full bg-white flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#0284FC]" strokeWidth={3} /></div><span className="text-white/80 text-sm font-medium">{text}</span></li>)}
              </ul>
              <a href="/covering-cuisine" className="inline-flex items-center gap-2 text-white font-semibold text-sm hover:underline">Voir les possibilités <PanelsTopLeft className="w-4 h-4" /></a>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
